import * as React from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import singleClickCheckout from "../../../assets/img/features/advanced-checkout.gif";
// import singleClickCheckout from "../../../assets/img/features/single-click-checkout.gif";

export default function AdvancedCheckout() {
  return (
    <Box
      sx={{
        width: "100%",
        padding:  {xs:"2rem 0", md:"10rem 0"},
        // backgroundColor: 'primary.dark',
        background: "linear-gradient(180deg, rgba(244, 249, 255, 0) 0%, #F4F9FF 100%)",
      }}
    >
      <Box
        sx={{
          height: "inherit",
          width: "inherit",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-evenly",
          alignItems: "center"
        }}
      >
        <Box>
          <img src={singleClickCheckout} alt="loading..." height={600} width={320} style={{borderRadius: '16px'}}/>
        </Box>
        <Box sx={{ width: { sx: "90vw", md: "40vw", padding: "2rem" } }}>
          <Typography variant="h3" gutterBottom fontWeight={800}>
          40%+ Higher conversion using Apik’s advanced discount engine
          </Typography>
          <Typography variant="h5" gutterBottom fontWeight={300} fontSize="1.2rem">
          Use Zomato/Nykaa like advanced discounting interface on your store. No need to remember and manually type discount codes.  
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
